<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="payment-hero__text">
        <h1 class="font-weight-bold">Bienvenidos a Progrentis FÓRUM</h1>
        <p class="text-hero section-space--mb_40">
          Un entorno para educadores destacados. Aprende a tu propio ritmo con
          nuestros cursos sobre las tendencias metodológicas que fomentan el
          aprendizaje competencial de los estudiantes.
        </p>
      </div>
    </div>
    <div class="col-lg-6">
      <div class="">
        <img
          src="@/assets/img/forum/imagen-header.png"
          alt="hero thumb"
          class="img-fluid"
          style="text-align: center; margin: 0 auto; display: block"
        />
        <div class="circulos-forum one"></div>
        <div class="circulos-forum two"></div>
        <div class="circulos-forum tree"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.circulos-forum{
    position: absolute;
    border-radius: 50%;
    animation: jump infinite 2s;
    animation-direction: alternate;
    background-color: #f76b1c;
    background-image: radial-gradient(79.16% 79.16% at 55.39% 17.41%, #FFF1BE 0%, #FFCC0D 69.19%, #FFAA01 100%);
    &.one{
        width: 142px;
        height: 142px;
        left: 20%;
        top: 18px;
    }

    &.two{
        width: 72.12px;
        height: 72.12px;
        left: 62%;
        bottom: 25px;
        margin-top: -8px;
        animation-delay: 1s;
    }
     &.tree{
        width: 36.52px;
        height: 36.52px;
        left: 74%;
        bottom: 105px;
        margin-top: -8px;
        animation-delay: 2s;
    }

    &--blue{
        background-color: #9C7AF2;
        background-image: linear-gradient(-224deg,#9C7AF2 0,#5E61E7 100%);
    }

    &--bg-blue{
        background: #5945e6;
        box-shadow: 0 2px 17px rgba(89,69,230,0.27);
    }
    &--bg-green {
        background: #38cb89;
        box-shadow: 0 2px 17px rgba(89,69,230,0.27);
    }
}


@keyframes jump{
    0% {
        transform: translateY(-10px) scale(0.9, 0.9);
    }
    100% {
        transform: translateY(10px) scale(1, 1);
    }
}
</style>